export default function Hero() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20moody%20editorial%20fashion%20flatlay%20featuring%20one%20premium%20leather%20sneaker%20angled%20diagonally%20across%20a%20textured%20linen%20surface%2C%20beside%20it%20a%20folded%20charcoal%20cashmere%20sweater%20and%20a%20minimalist%20watch%2C%20dramatic%20side%20lighting%20from%20a%20single%20source%20casting%20long%20artistic%20shadows%2C%20dark%20warm%20amber%20and%20ivory%20color%20palette%2C%20high-end%20boutique%20window%20display%20aesthetic%2C%20intentional%20sparse%20composition%20with%20generous%20negative%20space%2C%20luxury%20still%20life%20photography%2C%20rich%20contrast%20with%20deep%20blacks%20and%20soft%20highlights&width=1920&height=1200&seq=hero-bg-v2-superbuy-10&orientation=landscape"
          alt="Superbuy Spreadsheet product showcase"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-background-50/85 via-background-50/50 to-transparent"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-24 md:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="flex flex-col">
            <span className="inline-flex items-center gap-2 text-xs font-semibold tracking-widest uppercase text-primary-600 mb-6 bg-primary-50 px-4 py-2 rounded-full w-fit">
              <i className="ri-sparkling-line"></i>
              Updated Weekly
            </span>

            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-bold text-foreground-950 leading-tight mb-6">
              The Ultimate{' '}
              <span className="italic text-primary-500">Superbuy Sheet</span>{' '}
              Hub for Smart Shopping
            </h1>

            <p className="text-base md:text-lg text-foreground-600 leading-relaxed mb-8 max-w-lg">
              Discover updated Superbuy spreadsheet collections, in-depth product guides, QC tips, and shipping strategies. Your complete resource for finding the best products from trusted sellers.
            </p>

            <div className="flex flex-col sm:flex-row gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 bg-foreground-900 text-background-50 px-8 py-4 rounded-full font-semibold text-sm hover:bg-foreground-800 transition-all duration-300 cursor-pointer whitespace-nowrap group"
              >
                Superbuy Sheet
                <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 border-2 border-foreground-900 text-foreground-900 px-8 py-4 rounded-full font-semibold text-sm hover:bg-foreground-900 hover:text-background-50 transition-all duration-300 cursor-pointer whitespace-nowrap group"
              >
                Buy It Now
                <i className="ri-shopping-bag-3-line group-hover:scale-110 transition-transform"></i>
              </a>
            </div>

            <div className="flex flex-wrap items-center gap-6 mt-8 pt-8 border-t border-background-200/60">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-check-line text-accent-600 text-sm"></i>
                </div>
                <span className="text-xs text-foreground-500 whitespace-nowrap">Beginner Friendly</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-check-line text-accent-600 text-sm"></i>
                </div>
                <span className="text-xs text-foreground-500 whitespace-nowrap">Updated Frequently</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center">
                  <i className="ri-check-line text-accent-600 text-sm"></i>
                </div>
                <span className="text-xs text-foreground-500 whitespace-nowrap">Expert Resources</span>
              </div>
            </div>
          </div>

          <div className="hidden lg:flex items-center justify-center">
            <div className="relative w-full aspect-[4/5] max-w-md rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=Close-up%20editorial%20shot%20of%20a%20single%20luxury%20leather%20handbag%20placed%20on%20a%20polished%20concrete%20pedestal%2C%20soft%20diffused%20window%20light%20creating%20gentle%20gradients%20across%20the%20surface%2C%20reflection%20on%20the%20polished%20floor%20beneath%2C%20minimalist%20gallery-like%20setting%20with%20one%20green%20eucalyptus%20branch%20in%20a%20small%20ceramic%20vase%20to%20the%20left%2C%20sophisticated%20modern%20aesthetic%2C%20muted%20sage%20green%20and%20warm%20stone%20color%20palette%2C%20architectural%20product%20photography%2C%20serene%20and%20elevated%20composition&width=800&height=1000&seq=hero-right-v2-superbuy-11&orientation=portrait"
                alt="Superbuy Sheet fashion essentials"
                className="w-full h-full object-cover object-center"
              />
              <div className="absolute bottom-4 left-4 right-4 bg-background-50/90 backdrop-blur-sm rounded-xl p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-xs text-foreground-500">Latest Update</p>
                    <p className="text-sm font-semibold text-foreground-900">July 2026 Collection</p>
                  </div>
                  <span className="inline-flex items-center gap-1 text-xs font-medium text-accent-600 bg-accent-50 px-3 py-1.5 rounded-full">
                    <i className="ri-verified-badge-line"></i>
                    Verified
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}